import React from 'react'
import PropTypes from 'prop-types'
import { DCH } from 'assets/assets'
import './DrawerMenu.scss'
import './NavBar.scss'

const DrawerMenu = props => {
  const { renderLinks, renderSignOut } = props
  return (
    <div className='drawer-menu'>
      <div className='header'>
        <img src={DCH} alt='datacubed-health-logo' />
      </div>
      <div className='menu-links flexed column'>{renderLinks()}</div>
      <div className='footer'>{renderSignOut()}</div>
    </div>
  )
}

export default DrawerMenu

DrawerMenu.propTypes = {
  renderLinks: PropTypes.func,
  renderSignOut: PropTypes.func
}
